module.exports = function getResource(label, vars = []) {
    let resources = {
        payWithText: 'Payer avec'
    };

    return resources[label];
};
